module.exports = __webpack_public_path__ + "static/media/preventie.f4da1de9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/preventie.pdf
// module id = 966
// module chunks = 0